// extracted by mini-css-extract-plugin
export default {"section":"Contact_section__9Wxix","textArea":"Contact_textArea__X3UAC","btn":"Contact_btn__JzanX","logo":"Contact_logo__se+Uj","paragraph":"Contact_paragraph__gC7bF"};